@for (contact of product.contact_us_info; track contact) {
  <div i18n="">
      <label>{{contact.display_text}}</label>
      <span>{{contact.value}}</span>
      <hr />
  </div>
}
